export const PUBLIC = 'PUBLIC';
export const STAFF = 'STAFF';
export const ADMIN = 'ADMIN';
export const GLOBADMIN = 'GLOBADMIN';
